import { motion, useReducedMotion } from "framer-motion";

/** Sections glide in once as they enter the viewport – calm, 18 px, never on reduced motion. */
export const Reveal = ({ children, className, delay = 0, as = "div", testId, id }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={reduce ? false : { opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -10% 0px" }}
      transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay }}
      className={className}
      id={id}
      data-testid={testId}
    >
      {children}
    </Tag>
  );
};
